<template>
  <div
    class="main_bg"
    style="
      background-image: url('img/invite_main_bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    "
  >

  <div class="top__bg">
          <div class="title_top">
      <back-nav-last-page
        :icon="'img/backw.png'"
        :textColor="'#fff'"
        :backColor="'transparent'"
      />
    </div>
  </div>
    <div
      class="invite_box"
      style="background-image: url('img/invite_sign_bg.png')"
    >
      <div class="invite_title">
        <div>填写邀请码</div>
      </div>
      <input
        class="invite_input"
        type="text"
        v-model="invite_code"
        placeholder="请输入邀请码"
      />
      <div
        class="invite_button"
        style="background-image: url('img/invite_submit.png')"
        @click="submit"
      ></div>
    </div>
  </div>
</template>
  
<script>
import "@/assets/css/index.css";
import { bindInviteCode } from "@/api/ranking";
import BackNavLastPage from "@/components/backNavLastPage.vue";
export default {
  name: "invite",
  components: {
    BackNavLastPage,
  },
  data() {
    return {
      invite_code: "",
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/index?access_token=" + this.$route.query.access_token,
      });
    },
    submit() {
      if (this.invite_code == "") {
        this.$toast.fail("请填写邀请码");
        return;
      }
      let params = {
        invite_code: this.invite_code,
      };
      bindInviteCode(params)
        .then(
          (res) => {
            this.$toast.success("绑定成功");
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
  